import React from "react";
import log from "cslog";

import { ResponsiveBar } from "@nivo/bar";
import { startCase } from "lodash";
// import { getTableContent } from "../../../../../dynamicdata/parser";
import { getTableContent } from "../../../../junctionAbs";
import { mobile, parseStyle, tablet } from "../../../../juntion";

function parseBCData(table, gd) {
    if (!Array.isArray(gd.lines) || !Array.isArray(table)) {
        return [[], []];
    }
    return [
        table.map((row) => row[gd.xAxis]),
        table.map((row) => ({
            [gd.xAxis]: row[gd.xAxis],
            ...gd.lines.reduce((acc, line) => {
                acc[line.column] = row[line.column];
                // acc[`${line.column}Color`] = "hsl(151, 70%, 20%)";
                return acc;
            }, {}),
        })),
    ];
}

function BarChart({ id, db, device, gs, dydb, ctx }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    const graph_data = getTableContent(dydb, input.graphData);

    const [bc_keys, bc_data] = parseBCData(graph_data, input.graphData);

    const padding = mobile(device) ? ps.mobile.padding : ps.style.padding;
    log.d(padding, "Padding in BC");
    const four_padding =
        padding.type === "multiple"
            ? padding.params
            : {
                  top: padding.params,
                  right: padding.params,
                  bottom: padding.params,
                  left: padding.params,
              };

    return (
        <div
            style={{
                height: input.height || 200,
                width: "100%",
            }}
        >
            <ResponsiveBar
                data={bc_data}
                keys={input.graphData?.lines?.map((line) => line.column) || []}
                indexBy={input.graphData.xAxis}
                margin={{
                    // top: 50, right: 130, bottom: 50, left: 60
                    ...four_padding,
                }}
                padding={0.3}
                valueScale={{ type: "linear" }}
                indexScale={{ type: "band", round: true }}
                colors={{ scheme: "set1" }}
                groupMode={input.groupMode}
                layout={input.orientation === "v" ? "vertical" : "horizontal"}
                reverse={input.reverseDirection}
                enableGridX={input.enableGridX}
                enableGridY={input.enableGridY}
                defs={[
                    {
                        id: "dots",
                        type: "patternDots",
                        background: "inherit",
                        color: "#38bcb2",
                        size: 4,
                        padding: 1,
                        stagger: true,
                    },
                    {
                        id: "lines",
                        type: "patternLines",
                        background: "inherit",
                        color: "#eed312",
                        rotation: -45,
                        lineWidth: 6,
                        spacing: 10,
                    },
                ]}
                fill={[
                    {
                        match: {
                            id: "fries",
                        },
                        id: "dots",
                    },
                    {
                        match: {
                            id: "sandwich",
                        },
                        id: "lines",
                    },
                ]}
                borderColor={{
                    from: "color",
                    modifiers: [["darker", 1.6]],
                }}
                axisTop={null}
                axisRight={null}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    // legend: "country",
                    legend: "category",
                    legendPosition: "middle",
                    legendOffset: 32,
                }}
                axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    // legend: "food",
                    legend: "sale_quantity",
                    legendPosition: "middle",
                    legendOffset: -40,
                }}
                labelSkipWidth={12}
                labelSkipHeight={12}
                labelTextColor={{
                    from: "color",
                    modifiers: [["darker", 1.6]],
                }}
                legends={[
                    {
                        dataFrom: "keys",
                        // anchor: "bottom-right",
                        // direction: "column",
                        // translateX: 120,
                        // translateY: 0,
                        ...input.legends,
                        justify: false,
                        itemsSpacing: 2,
                        itemWidth: 100,
                        itemHeight: 20,
                        itemDirection: "left-to-right",
                        itemOpacity: 0.85,
                        symbolSize: 20,
                        effects: [
                            {
                                on: "hover",
                                style: {
                                    itemOpacity: 1,
                                },
                            },
                        ],
                    },
                ]}
                role="application"
                ariaLabel="Nivo bar chart demo"
                barAriaLabel={function (e) {
                    return (
                        e.id +
                        ": " +
                        e.formattedValue +
                        " in country: " +
                        e.indexValue
                    );
                }}
            />
        </div>
    );
}

export default BarChart;
